
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { ElementWrapper } from '@cloudscape-design/test-utils-core/selectors';
import { appendSelector } from '@cloudscape-design/test-utils-core/utils';

export { ElementWrapper };

import CodeViewWrapper from './code-view';


export { CodeViewWrapper };

declare module '@cloudscape-design/test-utils-core/dist/selectors' {
   interface ElementWrapper {
    
/**
 * Returns a wrapper that matches the CodeViews with the specified CSS selector.
 * If no CSS selector is specified, returns a wrapper that matches CodeViews.
 *
 * @param {string} [selector] CSS Selector
 * @returns {CodeViewWrapper}
 */
findCodeView(selector?: string): CodeViewWrapper;

/**
 * Returns a multi-element wrapper that matches CodeViews with the specified CSS selector.
 * If no CSS selector is specified, returns a multi-element wrapper that matches CodeViews.
 *
 * @param {string} [selector] CSS Selector
 * @returns {MultiElementWrapper<CodeViewWrapper>}
 */
findAllCodeViews(selector?: string): MultiElementWrapper<CodeViewWrapper>;
   }
}


ElementWrapper.prototype.findCodeView = function(selector) {
  let rootSelector = `.${CodeViewWrapper.rootSelector}`;
  if("legacyRootSelector" in CodeViewWrapper && CodeViewWrapper.legacyRootSelector){
    rootSelector = `:is(.${CodeViewWrapper.rootSelector}, .${CodeViewWrapper.legacyRootSelector})`;
  }
  // casting to 'any' is needed to avoid this issue with generics
  // https://github.com/microsoft/TypeScript/issues/29132
  return (this as any).findComponent(selector ? appendSelector(selector, rootSelector) : rootSelector, CodeViewWrapper);
};

ElementWrapper.prototype.findAllCodeViews = function(selector) {
  return this.findAllComponents(CodeViewWrapper, selector);
};


export default function wrapper(root: string = 'body') {
  return new ElementWrapper(root);
}
